export const MERIDIEMS = ["AM", "PM"] as const;

export type MeridiemType = (typeof MERIDIEMS)[number];

export type LanguageCodes = "en" | "es" | "zh";

export interface MessageTemplateTranslations {
  readonly language_code: LanguageCodes;
  readonly content: string;
  readonly content_raw: string;
}

export const ExpressionAndType = "and_";
export const ExpressionOrType = "or_";
export const MultipleBooleanExpressionTypes = [ExpressionAndType, ExpressionOrType] as const;

export interface Expression {
  model?: string;
  field?: string;
  op?: string;
  value?: String[] | string | boolean | null;
  type?: string;
}

export type ExpressionType = (typeof MultipleBooleanExpressionTypes)[number];

export interface ChainedExpression {
  type: ExpressionType;
  args: TagExpression[];
}

export type TagExpression = ChainedExpression | Expression;
